export const finalizeRoiForSlice = (circle, slice, id = Date.now()) => ({
  ...circle,
  id,
  slice,
  stats: null,
});
